fragment ChatSettingsKnowledgeFragment on ChatSettings {
    lookAndFeel {
        nudgeSettings {
            isEnabled
            message
        }
        secondaryColor
    }
}
